import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BookingPage from "@/pages/BookingPage";
import VehicleManagement from "@/pages/VehicleManagement";
import { SsoGate } from "@/components/SsoGate";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SsoGate><BookingPage /></SsoGate>} />
          <Route path="/vehiclemanagement" element={<VehicleManagement />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
